import {
    // eslint-disable-next-line no-restricted-imports -- Разрешаем импортировать StatefulTooltip
    StatefulTooltip as DirectStatefulTooltip,
    type StatefulTooltipProps as DirectStatefulTooltipProps,
} from '@direct-frontend/components';

export type StatefulTooltipProps = Omit<DirectStatefulTooltipProps, 'autoFocusProps'>;

const AUTO_FOCUS_PROPS = {
    contain: false,
    autoFocus: false,
    restoreFocus: false,
} as const;

/*
  Дефолтные autoFocusProps в библиотеке захватывают фокус, из-за чего открытый тултип блокирует
  взаимодействие с другими элементами и не закрывается при клике вне его.
*/
export const StatefulTooltip = (props: StatefulTooltipProps) => (
    <DirectStatefulTooltip {...props} autoFocusProps={AUTO_FOCUS_PROPS} />
);
